module.exports = __webpack_public_path__ + "files/6561a5f1a6e50436ecc438e08af4996d.svg";